import { Input } from "@appquality/appquality-design-system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useDebounce from "src/hooks/useDebounce";
import { useAppDispatch } from "src/store";
import { setSearch } from "../../redux/bugShow/actionCreator";

const SEARCH_DEBOUNCE_MS = 500;

export const Search = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const search = useSelector((state: GeneralState) => state.bugShow.search);
  const [currentSearch, setCurrentSearch] = useState(search ?? "");
  const debouncedSearch = useDebounce(currentSearch, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    if (debouncedSearch !== (search ?? "")) {
      dispatch(setSearch(debouncedSearch));
    }
  }, [debouncedSearch, dispatch, search]);

  return (
    <Input
      id="bug-search"
      key="bug-search"
      type="search"
      value={currentSearch}
      onChange={setCurrentSearch}
      placeholder={t("Search by title...")}
      aria-label={t("Search by title...")}
    />
  );
};
